import { NavLink, useLocation } from "react-router-dom";
import { Home, Scissors, Images, Phone, MoreHorizontal } from "lucide-react";
import { trackEvent } from "@/hooks/useBusinessData";

/**
 * App-style bottom pill navigation for mobile.
 * 5 pills: Home · Services · Photos · Call · More
 * CALL is the visually prominent primary action.
 */
export default function MobileStickyNav({ config }) {
  const location = useLocation();

  const items = [
    { key: "home",     to: "/",        label: "Home",     icon: Home },
    { key: "services", to: "/services",label: "Services", icon: Scissors },
    { key: "photos",   to: "/photos",  label: "Photos",   icon: Images },
    {
      key: "call",
      href: `tel:${config?.phone_tel || "+16788512947"}`,
      label: "Call",
      icon: Phone,
      prominent: true,
      event: "call_clicked",
    },
    { key: "more",     to: "/more",    label: "More",     icon: MoreHorizontal },
  ];

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-black/90 backdrop-blur-md border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-sticky-nav"
    >
      <ul className="grid grid-cols-5">
        {items.map((it) => {
          const I = it.icon;
          if (it.href) {
            return (
              <li key={it.key}>
                <a
                  href={it.href}
                  onClick={() => trackEvent(it.event, { source: "mobile_sticky" })}
                  data-testid={`mobile-nav-${it.key}`}
                  className="flex flex-col items-center justify-center gap-1 py-3 text-[10px] uppercase tracking-[0.18em] font-mono text-white"
                >
                  <span className="w-9 h-9 rounded-full flex items-center justify-center border transition-colors bg-white text-black border-white">
                    <I className="w-4 h-4" strokeWidth={1.4} />
                  </span>
                  {it.label}
                </a>
              </li>
            );
          }
          const isActive =
            it.to === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(it.to);
          return (
            <li key={it.key}>
              <NavLink
                to={it.to}
                end={it.to === "/"}
                data-testid={`mobile-nav-${it.key}`}
                className={`flex flex-col items-center justify-center gap-1 py-3 text-[10px] uppercase tracking-[0.18em] font-mono ${
                  isActive ? "text-white" : "text-zinc-400"
                }`}
              >
                <span
                  className={`w-9 h-9 rounded-full flex items-center justify-center border transition-colors ${
                    isActive ? "bg-white/10 border-white" : "border-white/25"
                  }`}
                >
                  <I className="w-4 h-4" strokeWidth={1.4} />
                </span>
                {it.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
